import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AnimatedButton } from '@/components/AnimatedButton';
import { LogOut, ShieldCheck, LogIn } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/hooks/useAuth';

export const AuthButtons = () => {
  const navigate = useNavigate();
  const { user, isAdmin, loading, signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
      toast.success('Logged out successfully');
      navigate('/');
    } catch (error) {
      toast.error('Error logging out');
    }
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  // Loading state
  if (loading) {
    return null;
  }

  // Admin is logged in - show admin panel and logout buttons
  if (user && isAdmin) {
    return (
      <div className="hidden md:flex items-center space-x-4">
        <Button
          variant="outline"
          size="sm"
          className="flex items-center gap-1"
          onClick={() => navigate('/admin-dashboard')}
        >
          <ShieldCheck className="h-4 w-4 mr-1" />
          Admin Panel
        </Button>
        <Button variant="destructive" size="sm" onClick={handleLogout}>
          <LogOut className="h-4 w-4 mr-1" />
          Logout
        </Button>
      </div>
    );
  }

  // Regular user is logged in - show dashboard and logout buttons
  if (user) {
    return (
      <div className="hidden md:flex items-center space-x-4">
        <Button variant="outline" size="sm" onClick={() => navigate('/dashboard')}>
          Dashboard
        </Button>
        <Button variant="outline" size="sm" onClick={handleLogout}>
          <LogOut className="h-4 w-4 mr-1" />
          Logout
        </Button>
      </div>
    );
  }

  // Nobody is logged in - show login and signup buttons
  return (
    <div className="hidden md:flex items-center space-x-4">
      <Button
        variant="outline"
        className="font-medium border-[#33C3F0] text-[#33C3F0] hover:bg-[#33C3F0]/10"
        onClick={handleLogin}
      >
        <LogIn className="h-4 w-4 mr-1" />
        Log in
      </Button>
      <AnimatedButton
        className="bg-[#33C3F0] hover:bg-[#0FA0CE] text-white"
        onClick={handleSignup}
      >
        Get Free Plan
      </AnimatedButton>
    </div>
  );
};
